import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarCheck } from 'react-icons/fa';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_STATUS_COLORS } from '../../styles/chartColors';

const COLORS = {
  present: CHART_STATUS_COLORS.positive,
  absent: CHART_STATUS_COLORS.negative,
  on_leave: CHART_STATUS_COLORS.warning,
  not_marked: CHART_STATUS_COLORS.neutral,
};

const AttendanceTodayCard = ({ attendance, classWiseStatus, actionLink, actionLabel = 'Mark Attendance' }) => {
  if (!attendance) return null;

  const data = [
    { key: 'present', name: 'Present', value: attendance.present },
    { key: 'absent', name: 'Absent', value: attendance.absent },
    { key: 'on_leave', name: 'On Leave', value: attendance.on_leave },
    { key: 'not_marked', name: 'Not Marked', value: attendance.not_marked },
  ];

  const pendingClasses = classWiseStatus
    ? classWiseStatus.filter((item) => !item.attendance_marked)
    : null;

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      <div className="card dash-card h-100">
        <div className="dash-card-header">
          <span className="dash-card-header-title">
            <FaCalendarCheck />
            <span>Attendance Today ({attendance.total_active_students} Students)</span>
          </span>
          {actionLink && <Link to={actionLink} className="dash-view-link">{actionLabel}</Link>}
        </div>
        <div className="dash-card-body">
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={80} paddingAngle={2}>
                {data.map((item) => (
                  <Cell key={item.key} fill={COLORS[item.key]} style={{ stroke: 'var(--color-surface)' }} strokeWidth={2} />
                ))}
              </Pie>
              <Tooltip />
              <Legend iconType="circle" />
            </PieChart>
          </ResponsiveContainer>

          {pendingClasses && (
            <div className="mt-2">
              <div className="small text-muted mb-2">
                {classWiseStatus.length - pendingClasses.length} of {classWiseStatus.length} classes marked
              </div>
              {pendingClasses.length > 0 && (
                <div className="dash-scroll-box d-flex flex-wrap gap-2">
                  {pendingClasses.map((item) => (
                    <span key={item.program_id} className="dash-chip dash-chip-alert">
                      {item.program_name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AttendanceTodayCard;
